import React from 'react'

export const Resume = () => {
  return (

    <div className="page">
      <h1 className="page-title">Curriculum</h1>
      <section>
        <article className="experience">
          <h2 className="page-subtitle">Experiencia</h2>
          <p>Llevo mas de un año como autodidacta en el campo del Desarrollo Web, diseñando y creando sitios y aplicaciones para Internet desde cero.</p>
        </article>

        <article>
          <h2 className="page-subtitle">Conocimiento</h2>
          <p>Desarrollo de aplicaciones y páginas web dinámicas basadas en el lenguaje JavaScript usando la arquitectura MERN Stack.</p>
        </article>

        <article>
          <h2 className="page-subtitle">Formación</h2>
          <ul>
            <li>Master en React por Victor Robles; Udemy 2024</li>
            <li>Desarrollo web con HTML5, CSS, JS AJAX PHP y MySQL por Juan Pablo De la Torre Valdez; Udemy 2024</li>
            <li>JavaScript Moderno por Juan Pablo De la Torre Valdez; Udemy 2024</li>
            <li>Node.js - Bootcamp Desarrollo Web inc. MVC y REST APIs por Juan Pablo De la Torre Valdez; Udemy 2024</li>

          </ul>
        </article>

        <article>
          <h2 className="page-subtitle">Proyectos personales</h2>
          <ul>
            <li>Accesorios de belleza y cuidados del cabello Nardis <a href="https://www.beautyndesigns.com" target="_blank">Ir al sitio</a></li>
            
          </ul>
        </article>
      </section>
    </div>
  )
}
